import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
	root: {},
	headerSpacing: {
		minHeight: '60px',
	},
}));
